module.exports = __webpack_public_path__ + "img/PRNT_04_mono_AE_00003.6187a69c.png";